<template>
  <div class="containerMod">
    <div v-if="loading" class="loading-container">
      <div class="loader"></div>
    </div>
    <div v-else>
      <div class="bloqueFicha" v-for="separata in separatas" :key="separata._id">
        <div>
          <div class="area">{{area(separata.area)}}</div>
        </div>
        <div class="contenido">
          <div class="linea1">
            {{separata.titulo}}
          </div>
          <div class="linea2">
            {{separata.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ')}}
          </div>
          <div class="linea3">
            {{separata.publicacion}}
          </div>
          <div class="lineaNum">
            {{separata.numero ? ('Número ' + separata.numero) : `` }}
            {{separata.volumen ? (' Volumen ' + separata.volumen) : `` }}
            {{separata.mes ? (' | ' + mes(separata.mes)) : `` }} - {{separata.anyo}}
          </div>
          <div class="linea3a">
            {{separata.recibido ? ('Recibido: ' + separata.recibido) : `` }}
          </div>
          <div class="linea3a">
            {{separata.papel ? 'Edición papel' : (separata.digital ? 'Edición digital' : ``)}}
            {{separata.papel ? (separata.digital ? ' | ' + 'Versión digital' : ``) : `` }}
          </div>
          <!-- <div class="linea3">
            {{separata.palsClave ? ('Pals. clave: ' + separata.palsClave) : `` }}
          </div> -->
          <div class="linea4">
            <div class="lineaResumen">
              <p class="resumen">Resumen</p>
              <p class="up" @click="verResumen(separata._id)" v-show="!resumenesVisibles.some(e => e === separata._id)">&dtrif;</p>
              <p class="down" v-show="resumenesVisibles.some(e => e === separata._id)" @click="ocultarResumen(separata._id)">&utrif;</p>
            </div>
            <p v-show="resumenesVisibles.some(e => e === separata._id)">{{separata.resumen}}</p>
          </div>
          <div class="linea4">
            <div class="lineaResumen">
              <p class="resumen">Abstract</p>
              <p class="up" @click="verAbstract(separata._id)" v-show="!abstractsVisibles.some(e => e === separata._id)">&dtrif;</p>
              <p class="down" v-show="abstractsVisibles.some(e => e === separata._id)" @click="ocultarAbstract(separata._id)">&utrif;</p>
            </div>
            <p v-show="abstractsVisibles.some(e => e === separata._id)">{{separata.abstract}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
export default {
  name: 'ShowSeparatas',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getSeparatas()
  },
  emits: ['scrollHidden', 'NoScrollHidden'],
  data () {
    return {
      separatas: [],
      resumenesVisibles: [],
      abstractsVisibles: [],
      desplegado: false,
      deploid: false,
      URLbase: '',
      loading: false,
      meses:
        ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio',
          'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      areas: ['Antropoespeleología', 'Bioespeleología', 'Geoespeleología', 'Otras']
    }
  },
  methods: {
    async getSeparatas () {
      try {
        this.loading = true
        const url = `${this.URLbase}/separatas/getSeparatas`
        const res = await fetch(url)
        this.separatas = await res.json()
        this.loading = false
      } catch (error) {
        alert(error)
        this.loading = false
      }
    },
    mes (numMes) {
      return this.meses[numMes - 1]
    },
    area (numArea) {
      return this.areas[numArea - 1]
    },
    verResumen (ID) {
      this.resumenesVisibles.push(ID)
      this.desplegado = !this.desplegado
    },
    verAbstract (ID) {
      this.abstractsVisibles.push(ID)
      this.deploid = !this.deploid
    },
    ocultarResumen (ID) {
      this.resumenesVisibles = this.resumenesVisibles.filter(e => e !== ID)
      this.desplegado = !this.desplegado
    },
    ocultarAbstract (ID) {
      this.abstractsVisibles = this.abstractsVisibles.filter(e => e !== ID)
      this.deploid = !this.deploid
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod {
  overflow-y: auto;
  height: 99%;
  margin-top: 3px;
  background-color: var(--gr-fo-for);
  color:rgb(2, 2, 2);
}
.bloqueFicha{
  margin-top: 10px;
  padding-bottom: 1px;
  display: grid;
  grid-template-columns: 26% 70%;
}
.area{
  /* width: 120px;
  height: 170px; */
  font-size: 80%;
  color: white;
  background-color: rgb(59, 133, 186);
  border-radius: 4px;
  box-shadow: rgb(87, 85, 85) 5px 5px 7px;
  margin: 0px 12%;
  padding-bottom:2px;
}
.contenido{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
  border-bottom: solid 0.5px rgb(136, 166, 180);
  padding-bottom: 5px;
  margin-bottom: 0px;
}
.linea1{
  text-align: left;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: rgb(30, 119, 161);
}
.linea2{
  font-size: 15px;
  font-weight:700;
}
.linea3{
  font-size: 14px;
  text-align: left;
}
.linea3a{
  font-size: 13px;
  text-align: left;
}
.linea4{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  white-space: pre-line;
  color:rgb(1, 56, 82)
}
.linea4 p{
  text-align: left;
}
.lineaNum{
  font-size: 14px;
  text-align: left;
  font-weight:700;
  color: rgb(90, 90, 90);
  margin: 0 2px 0 2px;
}
.lineaResumen{
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: 160%;
}
.resumen{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 15px;
  color: rgb(30, 119, 161);
}
.up, .down{
  cursor:pointer;
  font-size: 30px;
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 576px){
  .containerMod{
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .bloqueFicha{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%
  }
  .bloqueFicha div{
    width: 90%
  }
  .contenido{
    padding: 0px;
    margin-bottom: 0px;
  }
 .restoDatos{
    width: 100%;
    border-bottom: none;
  }
  .linea1, .linea2, .linea3, .linea4{
    text-align: left;
    padding-left: 15px;
    padding-right: 15px;
  }
  .lineaNum{
    padding: 0px 15px;
    margin:  5px 0 5px 0;
  }
  .linea2{
    /* font-size: 14px; */
    margin-top: 6px;
    margin-bottom: 6px;
    font-weight: 700;
  }
  .linea3a{
    font-size: 13px;
    text-align: left;
    padding-left: 15px;
}
  .containerEdiciones{
    width: 90%;
  }
  .bloqueEdicion{
    display: flex;
    flex-direction: column;
  }
  .area{
    /* height: 170px; */
    font-size: 100%;
    padding: 2px 5px 4px;
    margin-right: 0;
    margin-left: 15px;
    margin-bottom:13px;
    margin-top: 5px;
    box-shadow: none;
    background-color: rgb(247, 247, 247);
    border: solid 1.5px gray;
    color:gray;
  }
  .up, .down{
    margin:  2px 4px 0;
  }
}
</style>
